/// <reference types="vite/client" />
import { OTPData } from 'merchant-api/types';
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface getOTPDataProps {
  OPTDataLoading: boolean;
  OPTData: OTPData | any;
  OPTDataError: any;
  query: UseQueryResult<OTPData>;
}

const getOTPDataData = (id: string) =>
  spiceroad
    .get<OTPData>(`/v1/otpPreliminaryData/loan/${id}`)
    .then((res) => res.data);

export const getOTPDataOpts = (id: string) =>
  queryOptions<OTPData>({
    queryKey: ['otpData', id],
    queryFn: () => getOTPDataData(id),
  });

export function getOTPData(id: string): getOTPDataProps {
  const query = useQuery(getOTPDataOpts(id));
  const { data, error, isLoading } = query;
  return {
    OPTData: data,
    OPTDataLoading: isLoading,
    OPTDataError: error,
    query,
  };
}

export default getOTPData;
